import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'FieldValidator',
})
export class FieldValidatorPipe implements PipeTransform {
  transform(validationErrors: ValidationErrors): any {
    const errors: string[] = [];
    Object.keys(validationErrors!).forEach((error) => {
      switch (error) {
        case 'required':
          errors.push('This field is required.');
          break;

        case 'minlength':
          errors.push(
            `Minimum length should be ${
              validationErrors![error].requiredLength
            }.`
          );
          break;

        case 'maxlength':
          errors.push(
            `Maximum length exceeded (${
              validationErrors![error].requiredLength
            }).`
          );
          break;

        case 'pattern':
          errors.push('Invalid format.');
          break;

        case 'email':
          errors.push('Invalid email address.');
          break;

        case 'min':
          errors.push(
            `Value should be greater than or equal to ${
              validationErrors![error].min
            }.`
          );
          break;

        case 'max':
          errors.push(
            `Value should be less than or equal to ${
              validationErrors![error].max
            }.`
          );
          break;

        case 'requiredTrue':
          errors.push('This field must be checked.');
          break;
        case 'minDate':
          errors.push(
            `Date should be greater than or equal to ${(
              validationErrors![error].min as Date
            ).toLocaleDateString()}.`
          );
          break;
        case 'maxDate':
          errors.push(
            `Date should be less than or equal to ${(
              validationErrors![error].max as Date
            ).toLocaleDateString()}
            .`
          );
          break;
        // Add more cases for other common validators

        default:
          errors.push(`Unknown error: ${error}`);
          break;
      }
    });
    return errors;
  }
}
